import type { InventoryMovement } from "../models/InventoryMovement";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";
export function InventoryMovementService(warehouseCode?: string) {
  return CreateCrudService<InventoryMovement, KeyValue>({
    PaginationInPath: true,
    WarehouseCode: warehouseCode,
    Route: "inventory-movement",
    EntityName: "InventoryMovement",
    PartialFields: ["Code", "ProductCode"],
    LoadingMessage: "Loading inventory movements...",
    SavingMessage: "Saving inventory movement...",
  });
}
